import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import ListItem from "@/react-components/ListItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";

class SearchResult extends React.Component {
  render() {
    const { list, t, keyword, totalPage, pageIndex, onChange, showTitle } =
      this.props;
    return (
      <React.Fragment>
        {list.length > 0 ? (
          <div className="search-result-container">
            <div className="search-result-list">
              {showTitle && <h2>{t("TCMS01014_searchResult")}</h2>}
              {list.map((item, index) => (
                <ListItem item={item} key={index} keyWord={keyword} />
              ))}
            </div>
            <div className="pagination-container">
              <Pagination
                totalPage={totalPage}
                pageIndex={pageIndex}
                onChange={(page) => onChange && onChange(page)}
              />
            </div>
          </div>
        ) : (
          // 検索結果なしの場合
          <EmptyResult />
        )}
      </React.Fragment>
    );
  }
}

SearchResult.propTypes = {
  list: PropTypes.array.isRequired,
  keyword: PropTypes.string,
  totalPage: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showTitle: PropTypes.bool,
};

SearchResult.defaultProps = {
  keyword: "",
  showTitle: true,
};

export default withTranslation()(SearchResult);
